import React, {Component} from 'react'
import Dropdowns from '../../modules/Dropdowns'

const withSelectFetch = ({
  dropdown,
  name,
  cache = true,
  forceFetch = false,
}) => WrappedComponent => {
  return class extends Component {
    constructor(props) {
      super(props)
      this.state = {
        fetching: true,
        data: [],
      }
      this.dropdown = new Dropdowns({
        dropdown,
        name,
        cache,
        forceFetch,
      })
    }

    fetch = async forceFetch => {
      this.setState({
        fetching: true,
      })
      let data = await this.dropdown.get(forceFetch)
      this.setState({
        fetching: false,
        data,
      })
    }
    getData = async () => {
      await this.fetch(true)
    }

    async componentDidMount() {
      await this.fetch()
    }

    render() {
      return (
        <WrappedComponent
          fetching={this.state.fetching}
          data={this.state.data}
          fetch={this.getData}
          {...this.props}
        />
      )
    }
  }
}

export default withSelectFetch
